import React, { useState, useEffect, useRef, findDOMNode } from 'react';
import { Button, Row } from 'reactstrap';
import './avattavaboxi.css'
import { Table } from 'reactstrap';
import axios from "axios"

export default function AdminTopLista(props) {


  return (
    <div className="paperi" style={{ padding: "20px", width: "unset" }}>
      <Table style={{ fontSize: "23px", }} hover variant="dark" size="sm">
        <thead>
          <tr>
            <th>#</th>
            <th></th>
            <th>Nimi</th>
            <th>Valittu esine</th>
            <th>Vaihe</th>
            <th>Pisteet</th>
          </tr>
        </thead>
        <tbody>
          {props.users.map(function (item, i) {
            return (
              <tr>
                <th scope="row">{i + 1}</th>
                <th><img src={item.avatar} className="scoreAvatar"></img></th>
                <td>{item.username}</td>
                <td>{item.items && item.items.length ?
                  <img src={process.env.PUBLIC_URL + "/items/" + item.items[0] + ".png"} alt="itemin kuva" height={50} /> : "Ei valittu"}
                </td>
                <td>{item.level || 0}</td>
                <td>{item.points || 0}</td>
              </tr >)
          })}

        </tbody >
      </Table >
    </div >
  );

}
